import React from 'react'

function DeliveryBoys() {
  return (
    <div>DeliveryBoys</div>
  )
}

export default DeliveryBoys